import { Organisation } from "../../../../../api/OrganisationApi";

export default (organisations: Organisation[]): Organisation[] =>
  organisations.filter(organisation => {
    const notHousehold = organisation.type !== "household";
    const isTopLevel = !organisations.find(org => org.id == organisation.parent) ||
      organisation.parent == "intelicare";
    return notHousehold && isTopLevel;
  });